import { useEffect } from 'react';

// Publishes a sticky header's rendered height as a CSS variable on <html>
// so page-level sticky bars (e.g. Loans Hub tab strip) can sit just below it.
export function useStickyHeaderVar(ref, varName) {
  useEffect(() => {
    const root = document.documentElement;
    const apply = () => root.style.setProperty(varName, `${ref.current ? ref.current.offsetHeight : 0}px`);
    apply();
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return () => root.style.setProperty(varName, '0px');
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => { ro.disconnect(); root.style.setProperty(varName, '0px'); };
  });
}

// Tailwind arbitrary value: the tallest currently-stuck chrome bar.
export const STICKY_TOP_CLASS = 'top-[max(var(--bbc-tabs-bar-h,0px),var(--bbc-mobile-header-h,0px))]';
